import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { GET_SIDEBAR_CONFIGURATION } from '../store/actions';

const NavdataV2 = () => {
  const dispatch = useDispatch();
  const [menuState, setMenuState] = useState({});
  const [currentState, setCurrentState] = useState('');

  const { getSidebarConfiguration } = useSelector(state => ({
    getSidebarConfiguration: state.GetSidebarConfiguration.data,
  }));

  useEffect(() => {
    dispatch({ type: GET_SIDEBAR_CONFIGURATION });
  }, []);

  const toggleMenu = (key, e) => {
    e?.preventDefault?.();
    updateIconSidebar(e);
    setMenuState(prev => ({ ...prev, [key]: !prev[key] }));
    setCurrentState(key);
  };

  const updateIconSidebar = e => {
    if (e?.target?.getAttribute('subitems')) {
      const ul = document.getElementById('two-column-menu');
      const iconItems = ul?.querySelectorAll('.nav-icon.active') || [];
      [...iconItems].forEach(item => {
        item.classList.remove('active');
        const id = item.getAttribute('subitems');
        if (document.getElementById(id)) {
          document.getElementById(id).classList.remove('show');
        }
      });
    }
  };

  const getTimelineQueryParams = label => {
    const currentDate = moment();
    let startDate = '';
    let endDate = '';

    switch (label) {
      case 'Upcoming Bookings':
        startDate = currentDate.clone().add(2, 'days').toISOString();
        endDate = moment(new Date()).add(30, 'days').add(23, 'hours').add(59, 'minutes').add(59, 'seconds').add(999, 'milliseconds')?.toISOString();
        break;

      case 'Ongoing Bookings':
        startDate = currentDate.clone().subtract(2, 'days').toISOString();
        endDate = moment(new Date()).add(2, 'days').add(23, 'hours').add(59, 'minutes').add(59, 'seconds').add(999, 'milliseconds')?.toISOString();
        break;

      case 'Past Bookings':
        startDate = currentDate.clone().subtract(3, 'months').subtract(2, 'days').toISOString();
        endDate = moment(new Date())
          .subtract(2, 'days')
          .add(23, 'hours')
          .add(59, 'minutes')
          .add(59, 'seconds')
          .add(999, 'milliseconds')
          ?.toISOString();
        break;

      default:
        return '';
    }

    return `&startDate=${startDate}&endDate=${endDate}`;
  };

  const buildMenu = (items, parentKey) => {
    return items
      ?.sort((a, b) => a.priority - b.priority)
      .map(item => {
        const key = item.key;
        const hasChildren = item.children?.length > 0;

        const baseLink =
          item.route && item.cardName && item.cardType
            ? `${item.route}?name=${item.cardName}&type=${item.cardType}&nextNavigation=${item.nextNavigation}`
            : item.route || '#';

        const timelineParams = getTimelineQueryParams(item.label);
        const finalLink = timelineParams ? `${baseLink}&${timelineParams}` : `${baseLink}`;

        return {
          id: key,
          label: item.label,
          icon: 'ri-dashboard-2-line',
          link: item.route ? finalLink : '#',
          stateVariables: !!menuState[key],
          click: e => toggleMenu(key, e),
          subItems: hasChildren ? buildMenu(item.children, key) : [],
        };
      });
  };

  const menuItems = buildMenu(getSidebarConfiguration?.configurations || []);

  return <>{menuItems}</>;
};

export default NavdataV2;
